import CustomInput from "@/components/shared/CustomInput";
import DashboardConstants from "@/store/constants/dashboardRecords";
import TrashIcon from "@/components/shared/TrashIcon"
import GlobalConstants from "@/store/constants/global"

export default {
  name: "SafetyPlanImprovementPlanRecordsTable",
  components: {
    CustomInput,
    TrashIcon
  },
  data() {
    return {
      safetyPlanImprovementPlansFields: [
        {
          key: "plan",
          label: this.$t("hazardReductionTable.heading.hazardReduction"),
        },
        {
          key: "confirmer",
          label: this.$t("hazardReductionTable.heading.confirmer"),
        },
        {
          key: "binIcon",
          label: "",
        },
      ],
      statusFocusInput: {
        plan: false,
        confirmer: false,
      },
      formatSafetyPlanImproment: `cus-border-x-table-default cus-bg-header
        cus-cell-last-child-none cus-padding-table-none cus-bg-table cus-font-size-main
        print-table-cell-right-none cus-page-break html2canvas-page-break`
    };
  },
  methods: {
    showConfirmModal(orderId) {
      this.$bvModal.show('confirm-modal');
      this.$store.commit(GlobalConstants.COMMIT.setConfirmAttr, { attr: "safetyPlanImprovementPlans", orderId: orderId });
    },
    setSafetyPlanImproment(attr, value, index) {
      const path = ["safetyPlanImprovementPlans", index, attr];
      this.$store.commit(DashboardConstants.COMMIT.setValueRecord, { path: path, value: value });
      this.$store.commit(DashboardConstants.COMMIT.recalculateRevision);
    },
    addNewLineSafePlanImprovemntPlans() {
      this.$store.commit(DashboardConstants.COMMIT.addNewRecord, "safetyPlanImprovementPlans");
    },
    handleFocusLine(subAttr, index, status) {
      //handle lost focus
      let obj = { attr: "safetyPlanImprovementPlans", index: index, subAttr: subAttr, status: status };
      this.$store.commit(DashboardConstants.COMMIT.changeStatusFocus, obj);
      //recalculate revision
      !status && this.$store.commit(DashboardConstants.COMMIT.recalculateRevision);
    },
  },
  computed: {
    statusEditable() {
      return this.$store.getters[DashboardConstants.GETTERS.getStatusEditable];
    },
    diaryPrevious() {
      let safetyPlanImprovementRecord = this.$store.getters[DashboardConstants.GETTERS.getDiaryRevisions].safetyPlanImprovementPlans;
      return safetyPlanImprovementRecord;
    }
  }
};